<template>
  <v-layout align-center justify-center row fill-height>
    <v-flex xs12 sm8>
      <v-card>
        <v-card-title>
          <v-layout row wrap>
            <v-flex xs12>
              <div class="logo">MFP</div>
            </v-flex>
            <v-flex xs12>
              <h2>新しいアカウント</h2>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-text-field type="text" label="Email" v-model="email" />
          <v-text-field type="password" label="Password" v-model="password" /> {{errorMessage}}
        </v-card-text>
        <v-card-actions>
          <v-btn @click="createAccount()">作成</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import auth from '@/components/fireAuthInit'
import { mapActions, mapState } from 'vuex'
export default {
  data() {
    return {
      email: "",
      password: ""
    }
  },
  methods: {
    createAccount() {
      auth.createUserWithEmailAndPassword(this.email, this.password)
        .then(user => {
          this.$router.push('/login')
        })
        .catch(error => {
          alert(error)
        })
    },
  },
  computed: {
    ...mapState('auth', ["errorMessage"])
  }
}
</script>
<style lang="css" scoped>
div.logo {
  font-size: 20px;
  color: #ff5722;
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
}
</style>